var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('div',{staticClass:"bg-white p-3 rounded shadow-sm"},[_c('create-form',{attrs:{"on_submit":_vm.create,"form_data":_vm.form_data,"form_meta_data":_vm.form_meta_data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }